<div class="main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3">
    <div class="page-title-wrapper">
        <!-- No search input on this page, so the title takes the left slot of the toolbar row
             instead of stacking above it and leaving that space empty. -->
        <div class="d-flex justify-content-between align-items-center flex-row flex-wrap gap-3">
            <ms-page-title />

            <div class="d-flex gap-3">
                <ms-expense-search-filter
                    [filter]="userSessionService.expensesFilter"
                    (filterApplied)="onFilterApplied()" />

                <ms-sort-dropdown
                    [sortOptions]="sortOptions"
                    [selectedSortOption]="orderBy()"
                    (selectedSortOptionChange)="onSortChanged($event)" />

                <a *ifHasPermission="{requiredPermissions: [FinancialsPermission.CreateExpense], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}"
                    class="btn btn-primary" [routerLink]="['/expense/create']">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="me-1" />
                    Create Expense
                </a>
            </div>
        </div>
    </div>

    <ms-expense-list-table
        #expenseTable
        class="d-block mt-4"
        [filter]="userSessionService.expensesFilter"
        [orderByInput]="orderBy()"
        (orderByChanged)="onListOrderByChanged($event)" />
</div>
